<script>
    import reportService from '../v2-service.js';
    import { removeTags } from '../../../js/utils.js';
    import { format, locale } from 'svelte-i18n';
    import { flatten422Errors } from '../../../services/api.svelte.js';
    import dayjs from 'dayjs';
    import relativeTime from 'dayjs/plugin/relativeTime';
    import localizedFormat from 'dayjs/plugin/localizedFormat';
    import 'dayjs/locale/es';
    import 'dayjs/locale/en';

    dayjs.locale($locale);
    dayjs.extend(relativeTime);
    dayjs.extend(localizedFormat);

    let { onsave, oncancel, report = {} } = $props();

    let formData = $state({
        description: report.description || "",
        id: report.id
    });
    let formIsSubmitted = $state(false);
    let formApiErrors = $state({});

    async function handleSubmit(e) {
        if (e && typeof e.preventDefault === "function") e.preventDefault();
        formIsSubmitted = true;
        formApiErrors = {};

        let cleanData = { ...formData };
        if (typeof cleanData.description === 'string') {
            cleanData.description = removeTags(cleanData.description);
        } else {
            cleanData.description = "";
        }

        try {
            const savedReport = await reportService.patch(cleanData, []);
            onsave?.({ data: [savedReport] });
            formIsSubmitted = false;
            formApiErrors = {};
        } catch (errors) {
            formApiErrors = flatten422Errors(errors);
        }
    }

    function handleCloseModal(e) {
        if (e && typeof e.preventDefault === "function") e.preventDefault();
        formIsSubmitted = false;
        oncancel?.();
    }

    const handleKeydown = (event) => {
        if (event.key === "Escape") {
            handleCloseModal(event);
        }
    };
</script>

<svelte:window onkeydown={handleKeydown}/>

<form role="form" novalidate onsubmit={handleSubmit}>
    <div class="card mb-0">
        <div class="card-body">
            <div class="mb-3">
                <div>
                    <span><strong>{$format("creation_date")}</strong>:</span> <span>{dayjs(report.created_at).format("L, h:mm:ss a") || ""}</span>
                </div>
                <div class="mt-3">
                    <span><strong>{$format("format")}</strong>:</span> <span>{report.template?.includes(".") ? report.template.split(".")[1].toUpperCase() : (report.template?.toUpperCase() || "")}</span>
                </div>
                <div class="mt-3">
                    <span><strong>{$format("created_by")}</strong>:</span> <span>{report.created_by || ""}</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="reportAddDescription">{$format("form.fields.description")}:</label>
                <input
                    type="text"
                    class="form-control t-input-report-description"
                    id="reportAddDescription"
                    name="description"
                    placeholder={$format("form.fields.description")}
                    bind:value={formData.description}
                />
            </div>
        </div>
        <div class="card-footer">
            <button id="reportAddSubmit" type="submit" class="btn btn-primary t-submit-report-btn">{$format("buttons.save")}</button>
            <button type="button" class="btn btn-default" onclick={handleCloseModal}>{$format("buttons.cancel")}</button>
        </div>
    </div>
</form>